module.exports = __webpack_public_path__ + "img/DataGrip_icon.a4742b16.png";